'use strict';

var React = require('react');
var Card = require('../../DesignSystem/Surfaces/Cards/Card.js');
var CardActions = require('../../DesignSystem/Surfaces/Cards/CardActions.js');
var CardContent = require('../../DesignSystem/Surfaces/Cards/CardContent.js');
var CardHeader = require('../../DesignSystem/Surfaces/Cards/CardHeader.js');
var KanbanHeaderActions = require('./KanbanHeaderActions.js');
var classNames = require('classnames');
require('prop-types');
var useKanbanCardStyles = require('./useKanbanCardStyles.js');
var Theme = require('../../Theme/Theme.js');
require('../../Theme/DarkTheme.js');
require('../../Theme/LightTheme.js');
var CardActionArea = require('../../node_modules/@material-ui/core/esm/CardActionArea/CardActionArea.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var KanbanCard = function KanbanCard(props) {
  var classes = useKanbanCardStyles({
    footerBackgroundColor: props.footerBackgroundColor,
    cardBorder: props.cardBorder
  });
  !!props.rightHeaderActions || !!props.leftHeaderActions;
  return React__default["default"].createElement(Card, {
    className: classNames__default["default"](classes.card, {
      small: props.variant === 'small',
      large: props.variant === 'large'
    })
  }, React__default["default"].createElement(CardHeader, {
    title: React__default["default"].createElement(KanbanHeaderActions, {
      left: props.leftHeaderActions,
      right: props.rightHeaderActions,
      variant: props.variant
    }),
    disableTypography: true,
    className: classes.cardHeader,
    showDivider: false,
    noPadding: true
  }), React__default["default"].createElement(CardActionArea["default"], {
    className: classes.cardActionArea,
    onClick: props.onClick
  }, React__default["default"].createElement(CardContent, {
    className: classNames__default["default"](classes.cardContent)
  }, props.content), React__default["default"].createElement(CardActions, {
    className: classNames__default["default"](classes.cardFooter, {
      noFooter: !props.footer
    })
  }, !!props.footerAdornment && React__default["default"].createElement("div", {
    className: 'footer-adornment'
  }, props.footerAdornment), React__default["default"].createElement("div", {
    className: 'footer-text'
  }, props.footer))));
};

KanbanCard.defaultProps = {
  cardBorder: '1px solid transparent',
  content: null,
  footer: null,
  footerAdornment: null,
  footerBackgroundColor: Theme.theme.palette.secondary[100],
  leftHeaderActions: null,
  onClick: function onClick() {},
  rightHeaderActions: null,
  variant: 'standard'
};

module.exports = KanbanCard;
